import { EditorContent, useEditor } from '@tiptap/react';
import type { AdvisorDoc } from '@agio/core/domain';
import { advisorExtensions } from './advisorExtensions.js';
import { cn } from '../../utils.js';

/**
 * Read-only rendering of a stored summary, built from the same extension list
 * as the editor — no HTML string is ever injected into the page.
 */
export function AdvisorRichText({ doc, className }: { doc: AdvisorDoc; className?: string }) {
  const key = JSON.stringify(doc);
  const editor = useEditor(
    {
      extensions: advisorExtensions({ editable: false }),
      content: doc,
      editable: false,
      editorProps: { attributes: { dir: 'rtl', class: 'outline-none' } },
    },
    [key],
  );
  return <EditorContent editor={editor} dir="rtl" className={cn('advisor-prose', className)} />;
}
